import { getStackTrace, log } from '@src/Log.init';
import { rootApi } from './root.api';

export const referenceListApi = rootApi.injectEndpoints({
  tagTypes: ['ReferenceList'],
  endpoints: (builder) => ({
    getBaseReferenceLists: builder.query({
      query: () => ({
        url: 'basereferencelist',
        method: 'GET',
      }),
      providesTags: ['ReferenceList'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'ReferenceList',
          message: 'getBaseReferenceLists: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'ReferenceList',
            message: 'getBaseReferenceLists: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getBaseReferenceLists: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getReferenceLists: builder.query({
      query: () => ({
        url: 'referencelist',
        method: 'GET',
      }),
      providesTags: ['ReferenceList'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'ReferenceList',
          message: 'getReferenceLists: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'ReferenceList',
            message: 'getReferenceLists: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getReferenceLists: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    updateReferenceList: builder.mutation({
      query: (referenceList) => ({
        url: 'referenceList',
        method: 'PUT',
        body: referenceList,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['ReferenceList'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'ReferenceList',
          message: 'updateReferenceList: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'ReferenceList',
            message: 'updateReferenceList: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'updateReferenceList: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
  }),
});

export const {
  useGetBaseReferenceListsQuery,
  useLazyGetBaseReferenceListsQuery,
  useGetReferenceListsQuery,
  useLazyGetReferenceListsQuery,
  useUpdateReferenceListMutation,
} = referenceListApi;
